export default __webpack_public_path__ + "static/9-3dabf46f4ee207dddf1fd32a6dce9ec6.png";